var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.nodes.length)?_c('div',{staticClass:"c-loading"},[_c('spinner'),_vm._t("default",function(){return [_vm._v("Loading component...")]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }